// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  sessionTimeout: 1800000,
  filedownloadurl: "",
  headers: {
    "hash": "",
    "transaction": "",
    "senderagent": ""
  },
  headersv4: {
    "transaction": "",
    "hash": "",
    "senderagent": ""
  },
  "filedownloadurlv4": "",
  HandlerandRuleCreate: {
    HandlerPostJson: {},
    RulePostJson: {},
    InterfacePostJson: {}
  },
  RouteNameSuggest: []
};

